var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#AEB7BE;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notification"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M378.5,42.5h-19.8V22.8C358.8,11.8,349.9,3,339,3s-19.8,8.8-19.8,19.8v19.8H161.1V22.8 c0-10.9-8.8-19.8-19.8-19.8s-19.8,8.8-19.8,19.8v19.8h-19.8C47.3,42.5,3,86.9,3,141.4v229.3c0,54.5,44.3,98.8,98.8,98.8h79.1 c10.9,0,19.8-8.8,19.8-19.8s-8.8-19.8-19.8-19.8h-79.1c-32.7,0-59.3-26.6-59.3-59.3v-170h415.1c10.9,0,19.8-8.8,19.8-19.8v-39.5 C477.4,86.9,433,42.5,378.5,42.5z M437.8,161.1H42.5v-19.8c0-32.7,26.6-59.3,59.3-59.3h19.8v19.8c0,10.9,8.8,19.8,19.8,19.8 s19.8-8.8,19.8-19.8V82.1h158.1v19.8c0,10.9,8.8,19.8,19.8,19.8s19.8-8.8,19.8-19.8V82.1h19.8c32.7,0,59.3,26.6,59.3,59.3V161.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.8,
    cy: 260,
    r: 19.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.9,
    cy: 260,
    r: 19.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 260,
    r: 19.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.8,
    cy: 339,
    r: 19.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.9,
    cy: 339,
    r: 19.8
  })), /*#__PURE__*/React.createElement("path", {
    d: "M489.2,429.9c-10.9,0-19.8-8.9-19.8-19.8V339c0-54.5-44.3-98.8-98.8-98.8s-98.8,44.3-98.8,98.8v71.2 c0,10.9-8.9,19.8-19.8,19.8c-10.9,0-19.8,8.8-19.8,19.8s8.8,19.8,19.8,19.8h98.8v19.8c0,10.9,8.8,19.8,19.8,19.8 s19.8-8.8,19.8-19.8v-19.8h98.8c10.9,0,19.8-8.8,19.8-19.8S500.2,429.9,489.2,429.9z M308,429.9c2.2-6.2,3.4-12.8,3.4-19.8V339 c0-32.7,26.6-59.3,59.3-59.3s59.3,26.6,59.3,59.3v71.2c0,6.9,1.2,13.6,3.4,19.8H308z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.08041b21045174af55f4966a150a6ed1.svg";
export { ForwardRef as ReactComponent };